
import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const LoadingSpinner = ({ size = "md", className }: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-8 h-8", 
    lg: "w-12 h-12"
  };

  return (
    <div className={cn("flex items-center justify-center", className)}>
      <div
        className={cn(
          "animate-spin rounded-full border-2 border-gray-300 border-t-garage-blue",
          sizeClasses[size]
        )}
        role="status"
        aria-label="Ładowanie"
      >
        <span className="sr-only">Ładowanie...</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
